'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--ThunderCloud';

var EntypoThunderCloud = function EntypoThunderCloud(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M15.213,6.641c-0.276,0-0.546,0.023-0.809,0.066C13.748,4.562,11.715,3,9.309,3C6.37,3,3.989,5.328,3.989,8.199c0,0.258,0.02,0.51,0.057,0.756C3.904,8.939,3.762,8.928,3.617,8.928C1.619,8.928,0,10.512,0,12.463C0,14.416,1.619,16,3.617,16h11.596C17.856,16,20,13.904,20,11.32C20,8.734,17.856,6.641,15.213,6.641z M11.371,10.951c-0.494,0.703-2.614,2.889-2.704,2.98c-0.104,0.129-0.391,0.344-0.663,0.166c-0.079-0.051-0.172-0.152-0.172-0.354c0-0.193,0.088-0.391,0.098-0.412l1.033-2.287c-0.193-0.078-0.527-0.211-0.785-0.324l-0.068-0.029c-0.262-0.111-0.588-0.25-0.588-0.607c0-0.172,0.081-0.373,0.249-0.609c0.495-0.705,2.614-2.889,2.705-2.982c0.103-0.127,0.39-0.342,0.663-0.166c0.078,0.051,0.171,0.154,0.171,0.354c0,0.193-0.088,0.391-0.098,0.414l-1.034,2.285c0.195,0.078,0.528,0.213,0.787,0.324l0.068,0.029c0.262,0.111,0.588,0.25,0.588,0.609C11.621,10.514,11.539,10.713,11.371,10.951z' })
    );
};

exports.default = EntypoThunderCloud;
module.exports = exports['default'];